var _themes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import guid from '../utils/guid';
import styled, { keyframes } from 'styled-components';
import TscThemeName from '../constants/TscThemeName';
import tscStyles from '../constants/TscStyles';
import { getClassName } from '../utils/get-class-name';
var radioSize = '1.25rem';
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  borderColor: tscStyles.color.ui.dawn.dark,
  backgroundColor: tscStyles.color.ui.dawn.light
}), _defineProperty(_themes, TscThemeName.dusk, {
  borderColor: tscStyles.color.ui.dusk.lightMedium,
  backgroundColor: tscStyles.color.ui.dusk.dark
}), _themes);
var focusAnimation = keyframes(["0%{box-shadow:", " 0px 0px 0px 0px}50%{box-shadow:", " 0px 0px 0px 3px}100%{box-shadow:", " 0px 0px 0px 1px}"], tscStyles.color.action.primary, tscStyles.color.action.primary, tscStyles.color.action.primary);
var Container = styled.div.withConfig({
  displayName: "Radio__Container"
})(["position:relative;width:", ";height:", ";flex:0 0 auto;&:focus-within label{outline:none;animation:", " 500ms ease;box-shadow:0 0 0 1px ", ";border-color:", ";}"], radioSize, radioSize, focusAnimation, tscStyles.color.action.primary, tscStyles.color.action.primary);
var StyledLabel = styled.label.withConfig({
  displayName: "Radio__StyledLabel"
})(["display:flex;align-items:center;justify-content:center;position:absolute;top:0;right:0;bottom:0;left:0;background:", ";opacity:", ";border-radius:100%;border:0px solid ", ";border-width:", ";border:1px solid ", ";outline:", ";user-select:none;pointer-events:", ";cursor:pointer;transition:background 200ms ease,border 200ms ease;&:after{content:'';display:block;width:.75rem;height:.75rem;border-radius:100%;background:", ";transform:", ";opacity:", ";transition:all 250ms ease;}&:focus{outline:none;}&:hover{border-width:", ";}"], function (props) {
  return themes[props.themeName].backgroundColor;
}, function (props) {
  return props.disabled ? '.25' : '1';
}, function (props) {
  return themes[props.themeName].borderColor;
}, function (props) {
  return props.isSelected ? '4px' : '0px';
}, function (props) {
  return themes[props.themeName].borderColor;
}, function (props) {
  return props.isFocused ? 'solid 2px' : 'none';
}, function (props) {
  return props.disabled ? 'none' : 'all';
}, tscStyles.color.action.primary, function (props) {
  return props.isSelected ? 'scale(1)' : 'scale(0)';
}, function (props) {
  return props.isSelected ? '1' : '0';
}, tscStyles.border.radius.md);
var Input = styled.input.withConfig({
  displayName: "Radio__Input"
})(["width:0;height:0;opacity:0;"]);

var Radio = function Radio(_ref) {
  var className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      groupId = _ref.groupId,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      label = _ref.label,
      onChange = _ref.onChange,
      sharedId = _ref.sharedId,
      testId = _ref.testId,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dawn : _ref$themeName;
  // generate this once
  var internalId = React.useMemo(function () {
    return "radio-input-".concat(guid.new());
  }, []);

  var _React$useState = React.useState({
    isFocused: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var labelRef = React.useRef(null);

  var onFocus = function onFocus() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isFocused: true
    }));
  };

  var onBlur = function onBlur() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isFocused: false
    }));
  };

  var id = sharedId || internalId;
  return _jsxs(Container, {
    className: getClassName(className, null, 'radio-container'),
    children: [_jsx(StyledLabel, {
      className: getClassName(className, 'styled-label'),
      disabled: disabled,
      htmlFor: id,
      ref: labelRef,
      isFocused: state.isFocused,
      isSelected: isSelected,
      "data-test-id": "".concat(testId || 'tscsg-radio', "-label"),
      themeName: themeName
    }), _jsx(Input, {
      className: getClassName(className, 'styled-input'),
      id: id,
      type: "radio",
      checked: isSelected,
      readOnly: true,
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      onChange: onChange,
      "aria-label": label,
      name: groupId,
      "data-test-id": "".concat(testId || 'tscsg-radio', "-radio")
    })]
  });
};

var RadioTest = {
  Container: Container,
  Input: Input
};
export { Radio, RadioTest };
export default Radio;